import './sale-banner.scss';
